import React from 'react';
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {Button} from "@material-ui/core";

const useStyle = makeStyles((theme)=>({
    button: {
        backgroundColor: "#BB0D66",
        color: "#fff",
        width: "150px",
        "&:hover": {
            backgroundColor: "#8a0046"
        }
    },
}))
function AdviserRegisterSuccess(props) {
    const history = useHistory();
    const classes = useStyle();



    return (
        <React.Fragment>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', width:'100%'}}>
            <h2>Gracias por completar el registro</h2>

            <Button
                variant="contained"
                onClick={()=>history.push('/')}
                style={{marginTop:"24px"}}
                className={classes.button}
            >
                Finalizar
            </Button>
            </div>
        </React.Fragment>
    );
}

export default AdviserRegisterSuccess;